import { createAction, props } from '@ngrx/store';
import { CompleteProfilePayload } from '../models/personal-info.model';
import { UserProfileResponse } from '@/app/dashboard/models/dashboard.model';

export const enableEdit = createAction('[Personal Info] Enable Edit');
export const requestCancelEdit = createAction(
  '[Personal Info] Request Cancel Edit'
);
export const dismissCancelEdit = createAction(
  '[Personal Info] Dismiss Cancel Edit'
);
export const confirmCancelEdit = createAction(
  '[Personal Info] Confirm Cancel Edit'
);

export const updateProfile = createAction(
  '[Personal Info] Update Profile',
  props<{ profile: CompleteProfilePayload }>()
);
export const updateProfileSuccess = createAction(
  '[Personal Info] Update Profile Success',
  props<{ profile: UserProfileResponse }>()
);
export const updateProfileFailure = createAction(
  '[Personal Info] Update Profile Failure',
  props<{ error: string }>()
);
